var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-uploader',{attrs:{"after-read":_vm.uploadershang,"multiple":_vm.num>1?true:false,"max-count":_vm.num,"before-delete":_vm.deleteimg2},model:{value:(_vm.imageFile),callback:function ($$v) {_vm.imageFile=$$v},expression:"imageFile"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }